<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">{{page_title}}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" color="#ffffff"/>
        <span style="color: #ffffff" @click="toBack">返回</span>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>


    <van-cell-group title="课程列表">

      <van-list v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text=""
                @load="onLoad">
        <van-cell v-for="(item,index) in list" is-link :key="index" @click="toPlay(index)"
                  :title="item.name"/>
      </van-list>


    </van-cell-group>


  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      error_text: "",
      page_title:"在线理论课程",
      category:1,//课程类型：1理论2实操
      list: [],
    }
  },
  created() {

    if (undefined === this.$route.query.category || "" === this.$route.query.category || 1 == this.$route.query.category) {
      this.category = 1;
      this.page_title = "在线理论课程";
    }else {
      this.category= 2;
      this.page_title = "在线实操课程"
    }
  },
  methods: {
    onLoad() {
      this.list = [];
      this.loading = true;
      this.$http.get("/wechat/courses?category="+this.category).then(res => {
        console.log(res.data);
        this.loading = false
        if (200 !== res.data.code) {
          this.error = true
          this.error_text = res.data.msg
          return
        }
        if (!res.data.data || res.data.data.length <= 0) {
          //最终的选项了
          this.error = true
          this.error_text = "暂时没有课程"
          return
        }

        this.finished = true
        this.list = res.data.data;
      });
    },

    toPlay(index) {
      this.$router.push({path: '/course/details', query: {course_id: this.list[index].id}});
    },

    toBack() {
      this.$router.push('/');
    },

  }

}
</script>
